













import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";

@Component<VBANNER>({
  components: {
    dialogComp,
    "mt-button": Button,
  },
})
export default class VBANNER extends Vue {
  public show() {
    (this.$refs.dialog as any).show();
  }
  public close() {
    (this.$refs.dialog as any).close();
  }
  public goUrl() {
    location.href =
      "https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong";
  }
}
